








































































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import moment from 'moment';
import { User } from '@/types';

@Component
export default class About extends Vue {
  @State public user!: User;
  public timeSince: string = moment(new Date(2018, 12, 1, 1, 1, 1, 1)).toNow();
}
